import { action } from '@reatom/framework'
import i18next from 'i18next'

import { Result } from '@blade/std-lib'
import { OAuthCode } from '@root/entities/auth'
import { reatomRequest } from '@root/shared/lib'
import { showSnackbarAction } from '@root/shared/ui-kit'

import { parseTwitterAuthAction } from '../model'

import { assignTwitterAction } from './reatom-twitter-assign'
import { isUserExistsTwitterRequestAction } from './twitter-requests'

import type { TwitterAuthAction } from '../model'
import type { TypeHelper } from '@blade/std-lib'
import type { UserIsExistsTwitterListParams } from '@blade/trade-api-client'
import type { Deeplink } from '@root/entities/deeplinking'
import type { InviteCode } from '@root/entities/referral/model/referral-code'

export const handleTwitterAuthDeeplinkAction = action(
  async (ctx, deeplink: Deeplink.TwitterAuth) => {
    const authCode = deeplink.authCode ?? OAuthCode('')
    const parsedState = deeplink.state
      ? parseTwitterAuthAction(deeplink.state)
      : undefined

    if (parsedState?.action === 'assign') {
      assignTwitterAction(ctx, authCode)
      return
    }

    twitterUserExistenceCheckStateAtom.execute(ctx, {
      twitterAuthCode: authCode,
      referralCode: parsedState?.referralCode,
    })
  },
  'handleTwitterAuthDeeplinkAction',
)

export interface TwitterAuthData {
  code: OAuthCode
  action: TwitterAuthAction | undefined
  referralCode: InviteCode | undefined
}

export const twitterUserExistenceCheckStateAtom = reatomRequest({
  execAction: isUserExistsTwitterRequestAction,
  // eslint-disable-next-line @reatom/unit-naming-rule
  name: 'twitterUserExistenceCheckStateAtom',
  prepare: (
    _,
    args: UserIsExistsTwitterListParams & {
      twitterAuthCode: OAuthCode
      referralCode: InviteCode | undefined
    },
  ) => args,
  onResult: (ctx, result, [{ twitterAuthCode, referralCode }]) => {
    if (Result.isSuccess(result)) {
      if (result.success.exists) {
        loginWithTwitterDeeplinkEvent(ctx, {
          code: twitterAuthCode,
          action: 'login',
        })
      } else {
        registerWithTwitterDeeplinkEvent(ctx, {
          code: twitterAuthCode,
          action: 'register',
          referralCode,
        })
      }
      return
    }

    showSnackbarAction(ctx, {
      intent: 'error',
      text: i18next.t('auth.twitter-auth-error'),
      description: i18next.t('auth.twitter-auth-error-existence-check'),
    })
  },
})

// eslint-disable-next-line @reatom/unit-naming-rule
export const loginWithTwitterDeeplinkEvent = action<
  TypeHelper.OmitKey<TwitterAuthData, 'referralCode'>
>('loginWithTwitterDeeplinkEvent')
// eslint-disable-next-line @reatom/unit-naming-rule
export const registerWithTwitterDeeplinkEvent = action<TwitterAuthData>(
  'registerWithTwitterDeeplinkEvent',
)
